export default __webpack_public_path__ + "static/johnson-3dae0b4c81687b7dd9eb4462013e3ee6.webp";